String.prototype.e = function (p, o, i, ns) {
    let element = null;
    if (ns) {
        element = document.createElementNS(ns, this);
    } else {
        element = document.createElement(this);
    }
    if (p) {
        if (typeof (i) == "number") {
            if (p.children && p.children.length > 0 && p.children[i]) {
                p.insertBefore(element, p.children[i]);
            } else {
                p.appendChild(element);
            }
        }
        p.appendChild(element);
    }
    if (o) {
        Object.assign(element, o);
    }
    return element;
}
HTMLElement.prototype.e = function (v, o, i, ns) {
    return v.e(this, o, i, ns);
}
SVGElement.prototype.e = function (v, o, i) {
    return v.e(this, o, i, "http://www.w3.org/2000/svg");
}



// WEBPACK FOOTER //
// ./scripts/prototypes.js